import { gettextSeeAllPatients } from '@/shared/lib';

const SEE_ALL_PATIENTS_OPTIONS = [
  {
    label: gettextSeeAllPatients('Your studies'),
    value: 'Your studies',
  },
  {
    label: gettextSeeAllPatients('All studies'),
    value: 'All studies',
  },
];

export { SEE_ALL_PATIENTS_OPTIONS };
